import { Checkbox } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Controller, Control, FieldPath, FieldValues } from 'react-hook-form';

import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

export type CheckboxFieldProps<TFieldValues extends FieldValues = FieldValues> =
  FieldWrapperPassThroughProps & {
    labelElement: React.ReactNode;
    control: Control<TFieldValues>;
    name: FieldPath<TFieldValues>;
    onChange?: (checked: boolean) => void;
  };

export const CheckboxField = <TFieldValues extends FieldValues = FieldValues>(
  props: CheckboxFieldProps<TFieldValues>
): ReactElement => {
  const { error, labelElement, control, name, onChange } = props;

  return (
    <FieldWrapper error={error}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Checkbox.Root
            checked={field.value ?? false}
            colorPalette="green"
            onCheckedChange={({ checked }) => {
              const checkedValue = checked === true;
              field.onChange(checkedValue);
              onChange?.(checkedValue);
            }}
          >
            <Checkbox.HiddenInput />
            <Checkbox.Control>
              <Checkbox.Indicator />
            </Checkbox.Control>
            <Checkbox.Label>{labelElement}</Checkbox.Label>
          </Checkbox.Root>
        )}
      />
    </FieldWrapper>
  );
};
